import { Typography } from "@material-ui/core";
import { get } from "lodash";
import { useRecordContext } from "ra-core";
import React from "react";
import { parseToClientParts } from "../../utils/date";

interface Props {
  source: string;
  label?: string;
  addLabel?: boolean;
  className?: string;
  record?: any;
  showTime?: boolean;
  emptyText?: string;
  locales?: string | string[];
  options?: Intl.DateTimeFormatOptions;
}

const pad2 = (n: string) => n.padStart(2, "0");

/**
 * Render a datetime string from the record in canonical display format.
 * Marker-bearing values (Z / offset) are shown as Asia/Singapore wall time;
 * naive strings are shown literally, with no timezone shifting applied.
 */
const LocalDateField: React.FC<Props> = (props) => {
  const {
    source,
    label,
    addLabel,
    className,
    showTime = false,
    emptyText,
  } = props;
  const record = useRecordContext(props);
  if (!record) return null;

  const value = get(record, source);
  if (value == null || value === "") {
    return emptyText ? (
      <Typography component="span" variant="body2" className={className}>
        {emptyText}
      </Typography>
    ) : null;
  }

  const parts = parseToClientParts(String(value));
  let out: string;
  if (parts) {
    const [yyyy, mm, dd] = parts.date.split("-");
    const [hh, mi] = parts.time.split(":");
    if (showTime) {
      out = `${pad2(dd)}/${pad2(mm)}/${yyyy} ${hh}:${mi}`;
    } else {
      out = `${pad2(dd)}/${pad2(mm)}/${yyyy}`;
    }
  } else {
    out = String(value);
  }

  return (
    <Typography component="span" variant="body2" className={className}>
      {label && addLabel ? `${label}: ` : ""}
      {out}
    </Typography>
  );
};

LocalDateField.defaultProps = {
  addLabel: true,
};

export default LocalDateField;
